import axios from 'axios';
import LogRocket from 'logrocket';
import { Environment } from '../../../types/Environment';
import { getEnvironment } from '../../../utils/envUtils';
var authServiceUrl = '/dental/auth-service/register';
var recordingURL;
LogRocket.getSessionURL(function (sessionURL) {
  recordingURL = sessionURL;
});
export var verifyIdentity = function (taxId, captchaTokenValue) {
  return axios.post("".concat(authServiceUrl, "/verify?g-recaptcha-response=").concat(captchaTokenValue), {
    taxId: taxId
  }, {
    headers: {
      'X-LogRocket-URL': recordingURL
    }
  });
};
export var registerUser = function (taxId, email, password, firstName, lastName, role, termsAndConditions, tmxSessionId, captchaTokenValue) {
  return axios.post("".concat(authServiceUrl, "?tmx-session-id=").concat(tmxSessionId, "&g-recaptcha-response=").concat(captchaTokenValue), {
    employerTaxId: taxId,
    emailId: email,
    password: password,
    firstName: firstName,
    lastName: lastName,
    role: role,
    termsAndConditionsAccepted: termsAndConditions
  }, getEnvironment() === Environment.DEV ? {
    headers: {
      'x-forwarded-for': '127.0.0.1',
      'X-LogRocket-URL': recordingURL
    }
  } : {
    headers: {
      'X-LogRocket-URL': recordingURL
    }
  });
};
export var updateLastLogin = function (lastLogin, loginId, accessToken) {
  return axios.post("/dental/auth-service/users/update-last-login", {
    loginId: loginId,
    lastLogin: lastLogin
  }, {
    headers: {
      Authorization: "Bearer ".concat(accessToken),
      'X-LogRocket-URL': recordingURL
    }
  });
};